<script>

  export default {
    props: {
      values: {
        type: Array,
        default: ()=>([]),
      }
    },
    data() {
      return {
        items: [],
        addValuesFormData : {},
        rules: {
          AddValuesForm: {}
        }
      };
    },
    watch: {
    },
    methods: {
        isValid(){
            let isValid = false;
            let self = this;
            console.log('checking validation!');
            self.$refs["addValuesForm"].validate((formIsValid) => {
                if (formIsValid) {
                    isValid = true;
                }
                else {
                    self.$notify({
                        title: 'Ошибка',
                        message: 'Заполните доп. поля',
                        type: 'error',
                        duration: 3000,
                    });
                }
            });
            return isValid;
        },
      async init() {

      },
      FocusOnStepButton(e){
        if(e) e.preventDefault();
        return false;
      },
      FillAddValuesForm(){
        var self = this;
        this.values.forEach(function(item){
            let fieldName = item.AdditionalTypeId.toString();
            item.FieldName = fieldName;
          self.$set(self.addValuesFormData, fieldName, item);
          if(item.AdditionalValueTypeId == 4){
              item.Value = +item.Value || 0;
          }
          if(item.AdditionalValueTypeId == 1){
              if (item.Value == 'true'){
                  item.Value = true;
              }
              else if (item.Value == 'false' || (item.Value != true && item.Value != false)){
                  item.Value = false
              }
          }
        });
      },
      NonEmptyOrZero(data, value, callback){
          let isValid = value instanceof Array
            ? value.length > 0
            : !(value == 0 || value == null || value == undefined || value == '');

          if (isValid){
            callback();
          }
          else{
            callback(new Error(data.message));
          }
      },
      NonEmptyOrZeroTest(data, value, callback){
          debugger;
          this.NonEmptyOrZero(data, value, callback);
      }
    },
    computed: {
    },
    mounted(){
      this.$watch("values.length", this.FillAddValuesForm);
      if(this.values.length) {
        this.FillAddValuesForm();
      }
      this.init();
    },
  };
</script>
<template>
  <div
    class="mag-addvalues"
    v-if="values"
  >

    <el-form label-position="top" :model="$props" ref="addValuesForm"
             @keydown.enter.prevent="FocusOnStepButton" @submit.prevent>
      <div v-show="values.length > 0" v-for="(item, index) in values" :key="item.AdditionalTypeId">
        <div style="margin-bottom: 10px;" v-if="item.AdditionalTypeId">
<!--          <div>-->
<!--            {{item.AdditionalValueTypeId}} ({{item.Required}}):-->
<!--          </div>-->
          <div v-if="item.AdditionalValueTypeId == 1">
            <el-checkbox v-model="item.Value">{{item.Title}}</el-checkbox>
          </div>
          <div v-if="item.AdditionalValueTypeId == 3">
            <span>{{item.Title}}</span>
            <br/>
            <el-form-item label="" :prop="`values[${index}].Value`" :rules="item.Required ? { validator: NonEmptyOrZero, message: 'Обязательное поле', trigger: 'input' } : undefined">
              <el-date-picker v-model="item.Value" format="dd.MM.yyyy" type="date"
                              :picker-options="{firstDayOfWeek: 1}" :placeholder="item.Title">
              </el-date-picker>
            </el-form-item>
          </div>
          <div v-if="item.AdditionalValueTypeId == 4">
            <span>{{item.Title}}</span>
            <br/>
            <el-form-item label="" :prop="`values[${index}].Value`" :rules="item.Required ?  { validator: NonEmptyOrZero, message: 'Обязательное поле', trigger: 'input' } : undefined">
              <el-select v-model="item.Value" :placeholder="item.Title">
                <el-option
                        v-for="option in item.Options"
                        :key="option.Id"
                        :label="option.Value"
                        :value="option.Id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if="item.AdditionalValueTypeId == 5">
            <span>{{item.Title}}</span>
            <br/>
            <el-form-item label="" :prop="`values[${index}].SelectedOptions`" :rules="item.Required ? { validator: NonEmptyOrZero, message: 'Обязательное поле', trigger: 'input' } : undefined">
              <el-select v-model="item.SelectedOptions" multiple :placeholder="item.Title">
                <el-option
                        v-for="option in item.Options"
                        :key="option.Id"
                        :label="option.Value"
                        :value="option.Id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if="item.AdditionalValueTypeId == 6">
            <span>{{item.Title}}</span>
            <br/>
            <el-form-item label="" :prop="`values[${index}].Value`" :rules="{ required: item.Required, message: 'Обязательное поле', trigger: 'input' }">
              <input-address :placeholder="item.Title"  v-model="item.Value"></input-address>
            </el-form-item>
          </div>
          <div v-if="!(item.AdditionalValueTypeId == 6 || item.AdditionalValueTypeId == 1 || item.AdditionalValueTypeId == 3 || item.AdditionalValueTypeId == 4 || item.AdditionalValueTypeId == 5)">
            <span>{{item.Title}}</span>
            <br/>
            <el-form-item label="" :prop="`values[${index}].Value`" :rules="{ required: item.Required, message: 'Обязательное поле', trigger: 'input' }">
              <el-input :placeholder="item.Title" v-model="item.Value"></el-input>
            </el-form-item>

          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<style lang="scss">

</style>
